<template>
    <div>
    <div style="position:relative;">
        <div style="position:absolute;top:0;left:0;width:100%;padding:15px;z-index:2;" >
            <v-select solo rounded dense hide-details :value="value?.locationParent || null" :items="[{value:null, text:'Positie overnemen van adres'},{value:'measurements', text:'Positie overnemen van meetwaardes'}]" @change="updatePosition"></v-select>
    </div>
    <div class="map" :ref="mapId"></div>
</div>
</div>
</template>
<style lang="scss" scoped>
    .map{
        width:100%;
        padding-bottom: 100%;
        z-index: 1;
    }
</style>
<script>
import {v4 as uuidv4} from 'uuid';
import useLeaflet from '../plugins/leaflet';
    export default{
        name: 'eod-location-form',
        props:{
            value:{
                type: Object,
                default: null
            },
            disabled: Boolean,
            filters: {
                type: Object,
                default: () => ({})
            }
        },
        data(){
            return {
                mapId: 'map-'+(uuidv4()),
                map: null,
                marker: null
            }
        },
        mounted(){
            this.initMap();
        },
        methods:{
            // Keuzelijst gewijzigd door de gebruiker: waarde doorgeven EN de kaart bijwerken.
            async updatePosition(val){
                if(this.value){
                    // Muteer het bestaande object i.p.v. een kopie te emitten: een spread
                    // maakt er een plat object van en sloopt de klasse-getters van het
                    // model (bv. Product.serviceId, *DateFormatted) → lege verplichte
                    // velden en een valse 'verplichte velden'-melding (#1519).
                    this.$set(this.value, 'locationParent', val);
                    this.$emit('input', this.value);
                } else {
                    this.$emit('input', {locationParent: val});
                }

                await this.applyPosition(val);
            },
            // Plaatst enkel de marker op de kaart, zonder input-event: bij het openen
            // van het tabblad Locatie mag er niets aan het item wijzigen (#1519).
            async applyPosition(val){
                if(!val){
                    if(this.value && this.value.lat && this.value.lon){
                        this.positionMarker(this.value.lat, this.value.lon);
                    }
                } else {
                    const {lat, lng} = await this.$eod.getLatLng(this.filters);

                    if(!lat || !lng){
                        if (this.marker) {
                            this.marker.remove();
                            this.marker = null;
                        }

                        return;
                    }

                    this.positionMarker(lat, lng);
                }
            },
            positionMarker(lat, lon){
                let bounds = [];
                const pos = [lat, lon];
                bounds.push(pos);

                if(!this.marker){
                    this.marker = this.createMarker(pos);
                }else{
                    this.marker.setLatLng(pos, {
                        draggable: this.disabled?false:true
                    }).update();
                }
                
                if (bounds.length > 0) {
                    this.map.fitBounds(bounds, { padding: [25, 25], maxZoom:18 });
                }
            },
            createMarker(pos) {
                const self = this;

                let icon = this.$leaflet.divIcon({
                    html: this.getMarkerHtml(),
                    iconSize: [30, 34],
                    iconAnchor: [15, 38],
                    className: ''
                });

                const marker = this.$leaflet.marker(pos, { icon: icon, draggable: this.disabled?false:true });

                marker.on('dragend', function(event) {
                    var position = marker.getLatLng();
                    self.positionMarker(position.lat, position.lng);
                    self.updateValue(position.lat, position.lng);
                });

                marker.addTo(this.map);

                return marker;
            },
            updateValue(lat, lon){
                if(this.value){
                    const val = this.value;
                    val.lat = lat?parseFloat(lat):null;
                    val.lon = lon?parseFloat(lon):null;
                    this.$emit('input', val);
                }
            },
            getMarkerHtml() {
                return '<div class="eod-marker primary"><div class="triangle" style="border-top-color:var(--v-primary-base);"></div><i style="color:#ffffff;" class="mdi mdi-circle"></i></div>';
            },
            initMap() {
                if (!this.$refs[this.mapId]) {
                    return false;
                }

                if (this.map) {
                    this.map.remove();
                    this.map = null;
                }

                this.map = useLeaflet(this.$refs[this.mapId], {
                    zoom: 13,
                    zoomControl: false,
                    satellite:false
                });

                this.applyPosition(this.value?.locationParent || null);

                this.$leaflet.control.zoom({
                    position: 'bottomleft',
                }).addTo(this.map);
            },
        }
    }
</script>